@if (layout === 'engagement') {
  <div class="bg-lBlack light:bg-lGray950 border border-lGray800 rounded-2xl p-5 h-full flex flex-col gap-3 min-h-0">
    <div class="flex items-center gap-3 min-w-0">
      <span class="w-9 h-9 rounded-xl bg-lGray700 flex items-center justify-center shrink-0">
        <l-icon class="text-lWhite text-lg leading-none">{{ metric.icon }}</l-icon>
      </span>
      <p
        class="text-color text-base font-semibold leading-snug truncate min-w-0"
        [title]="metric.title"
      >{{ metric.title }}</p>
    </div>

    <div class="flex items-center justify-between gap-4">
      <div class="flex items-baseline gap-2 min-w-0">
        <p class="text-color text-3xl font-bold leading-none shrink-0">{{ metric.percentage }}%</p>
        <p class="text-base font-normal subtext-color truncate">
          ({{ metric.absoluteValue }} {{ metric.absoluteLabel }})
        </p>
      </div>

      <l-dashboard-trend-list [trends]="metric.trends" variant="extended" />
    </div>

    <div class="mt-auto">
      <l-dashboard-progress-bar [value]="metric.percentage" />
    </div>
  </div>
} @else {
  <div class="h-full min-h-[10.5rem] flex flex-col justify-between">
    <div class="flex items-start justify-between gap-6">
      <div>
        <p class="text-color text-base font-semibold">{{ metric.title }}</p>
        <p class="text-base font-normal subtext-color mt-2">
          ({{ metric.absoluteValue }} {{ metric.absoluteLabel }})
        </p>
      </div>

      <l-dashboard-trend-list [trends]="metric.trends" variant="compact" />
    </div>

    <div class="mt-6 flex flex-col gap-2">
      <p class="text-color text-3xl font-bold leading-none">{{ metric.percentage }}%</p>
      <l-dashboard-progress-bar [value]="metric.percentage" />
    </div>
  </div>
}
